import { AboboCrypto } from '@utils/aboboCrypto';
import { useApplicationContext } from "@contexts/ApplicationContext";

const useEncryption = () => {
  const { clientPublicKey } = useApplicationContext();

  const encrypt = async (data: any) => {
    if (!clientPublicKey) {
      throw new Error('Client public key not available');
    }
    const result = await AboboCrypto.encryptPayloadAndWrapKey(data, [clientPublicKey]) as [Uint8Array, Uint8Array[]];
    const [encryptedPayload, [clientWrappedKey]] = result;

    const encodedClientKey = AboboCrypto.uInt8ArrayToBase64(clientWrappedKey);

    return {
      encryptedValue: encryptedPayload as Uint8Array,
      encryptionKey: encodedClientKey,
    };
  };

  return encrypt;
};

export default useEncryption;
